import { tv } from "../../variants/tv.js";
const spinnerVariants = tv({
    slots: {
        circleSlot: '',
        spinnerSlot: '',
        iconSlot: 'text-primary-8',
        wrapperSlot: 'animate-fade-in-0-100'
    },
    variants: {
        size: {
            xs: {
                wrapperSlot: 'w-4'
            },
            sm: {
                wrapperSlot: 'w-6'
            },
            md: {
                wrapperSlot: 'w-16'
            },
            lg: {
                wrapperSlot: 'w-28'
            },
            xl: {
                wrapperSlot: 'w-36'
            }
        },
        emphasis: {
            regular: '',
            medium: '',
            bold: ''
        }
    },
    defaultVariants: {
        size: 'md',
        emphasis: 'regular'
    },
    compoundVariants: [
        {
            emphasis: 'regular',
            class: {
                circleSlot: 'var(--color-primary-4)',
                spinnerSlot: 'var(--color-primary-8)'
            }
        },
        {
            emphasis: 'medium',
            class: {
                circleSlot: 'var(--color-primary-7)',
                spinnerSlot: 'var(--color-primary-8)'
            }
        },
        {
            emphasis: 'bold',
            class: {
                circleSlot: 'color-mix(in oklab, var(--color-actionSecondary-1) 20%, transparent)',
                spinnerSlot: 'var(--color-primary-2)',
                iconSlot: 'text-primary-2'
            }
        }
    ]
});
const sizeOptions = Object.keys(spinnerVariants.variants.size);
const emphasisOptions = Object.keys(spinnerVariants.variants.emphasis);
export { emphasisOptions, sizeOptions, spinnerVariants };
